<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <h3 class="subtitle">
          Status de votre commande :
          <span
            class="orange--text text--darken-1"
          >{{order.job.jobStatus}}</span>
        </h3>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <h3>Vos fichiers:</h3>
      </v-col>
      <v-col cols="3" v-for="file in order.job.files" :key="file.id">
        <v-card>
          <b-b-image :file="file" />
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import BBImage from "./BBImage";
export default {
  components: {
    BBImage
  },
  props: {
    order: {
      type: Object,
      required: true
    }
  },
  computed: {},
  mounted() {},
  methods: {}
};
</script>

<style>
</style>